import { render } from "./EditNameEng.vue?vue&type=template&id=cfb1364c"
import script from "./EditNameEng.vue?vue&type=script&lang=js"
export * from "./EditNameEng.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__